export function getIssueDomain(months: {netIssuedQuantity: number | null}[]): [number, number] {
  const values = months.flatMap((month) =>
    month.netIssuedQuantity === null ? [] : [month.netIssuedQuantity]
  );
  return [Math.min(0, ...values), Math.max(0, ...values)];
}
